import { useAnimationStep } from "@/utils/animation/useAnimationStep";
import { type UseModals } from "components/modal/hooks/useModals"
import type { CSSProperties } from "vue";
import { Modal } from "components/modal/components/modal";
import { MODAL_CONTAINER_ANIMATION_DURATION } from "components/modal/constants";

export const ModalContainer = defineComponent<{
  hook: UseModals
}>((props) => {
  const modals = computed(() => unref(props.hook.items));
  const modalCount = computed(() => unref(props.hook.count));
  const hasModals = computed(() => modalCount.value > 0);
  const animation = useAnimationStep({
    initial: 0.0,
    duration: MODAL_CONTAINER_ANIMATION_DURATION
  });

  watch(hasModals, (has) => {
    animation.to(Number(has));
  }, { immediate: false });

  const style = computed((): CSSProperties => {
    return {
      width: '100vw',
      position: 'fixed',
      left: 0,
      top: 0,
      overflow: 'hidden',
      zIndex: 400,
      pointerEvents: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100svh',
    }
  });

  return () => {
    return <div style={style.value}>
      {
        modals.value.map((modalRef) => {
          const modal = unref(modalRef);
          return <Modal modal={modalRef} hook={props.hook} key={modal.id}/>
        })
      }
    </div>;
  }
}, { props: ['hook'] });
